import { createApiDescription } from "../../helperFunctions";

export const inProcessGatherInfo = {
    getAllInProcessGather: createApiDescription(
        "GET In-Process Gather API provides results based on the given filters on the request parameters. There are default filters if none are explicitly applied. Please consult request model for default filters.",
        [
            "The default number of returns in the response will be 10."
        ]
    ),
    deleteInProcessGather: createApiDescription(
        "This API can be called to delete the in-process Gather request.",
        [
            "Delete In Process gather API removes the document permanently from Gather In process page.",
            "Delete In-Process gather supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header."
        ]
    ),
}